import React, { useState, useEffect } from 'react';
import { Marker } from 'react-leaflet';
import {  IconObservation  } from '../../Icons/IconObservation';
import _ from 'lodash';
import ObservationModal from './ObservationModal';
import { observationService } from '@iso/services';
import btnSaveAction from '@iso/redux/btnSave/actions';
import { useDispatch, useSelector } from 'react-redux';
import modalActions from '@iso/redux/modal/actions';
import {message} from 'antd';
const { show } = btnSaveAction;
const { openModal } = modalActions;

const Observation = (props) => {
  const [observations, setObservations] = useState([]);
  const [dataObservation, setDataObservation] = useState({});
  const [primaryObjects, setPrimaryObjects] = useState([]);
  const objectRef = React.useRef([]);
  const dispatch = useDispatch();
  const saveSuccess = useSelector((state) => state.btnSave.saveSuccess);
  const cancelSave = useSelector((state) => state.btnSave.cancelSave);
  const dataTransfer = useSelector((state) => state.btnSave.data);
  const modalData = useSelector((state) => state.modal.modalData);

  const filterActiveObservations = React.useCallback((items = []) => {
    const now = Date.now();
    return _.filter(items, (item) => {
      const isApproved = item?.latest_approval?.status === 'approved';
      if (!isApproved) {
        return false;
      }
      if (!item?.expires_at) {
        return true;
      }
      const expiresAt = Date.parse(item.expires_at);
      if (Number.isNaN(expiresAt)) {
        return true;
      }
      return expiresAt > now;
    });
  }, []);

  const updateDataObservations = React.useCallback((propertyId) => {
    observationService.getList(propertyId, { only_active: 1 }).then(res => {
      if(res.code === '0000'){
        setObservations(filterActiveObservations(res.observations));
      }
    })
  }, [filterActiveObservations]);

  useEffect(() => {
    setPrimaryObjects(props.primaryObjects);
  }, [props.primaryObjects]);

  useEffect(() => {
    if(props.propertyId){
      updateDataObservations(props.propertyId);
    }
  }, [updateDataObservations, props.propertyId]);

  useEffect(() => {
    const handleRefresh = (event) => {
      const eventPropertyId = event?.detail?.propertyId;
      if (!eventPropertyId || eventPropertyId === props.propertyId) {
        props.propertyId && updateDataObservations(props.propertyId);
      }
    };
    window.addEventListener("observation:refresh", handleRefresh);
    return () => {
      window.removeEventListener("observation:refresh", handleRefresh);
    };
  }, [props.propertyId, updateDataObservations]);

  const saveLocation = React.useCallback((observation, dataTransfer) => {
    var layer = objectRef.current[observation.id].leafletElement;

    var point = dataTransfer.points;

    const data = {
      observation:{
        ...observation,
        point
      }
    }
    observationService.storeOrUpdateObservation(data, observation.id).then(res => {
      if(res.code === '0000'){
        updateDataObservations(res.observation.property_id)
        layer.editing.disable();
      }
    });

  }, [updateDataObservations]);

  const cancelSaveArea = React.useCallback((propertyId, dataObjectId) => {
    var layer = objectRef.current[dataObjectId].leafletElement;
    layer.editing.disable();
  }, []);



  useEffect(() => {
    if(saveSuccess && dataTransfer.type === 'observation' && dataObservation){
      saveLocation(dataObservation, dataTransfer);
    } else if (cancelSave && dataTransfer.type === 'observation'){
      cancelSaveArea(props.propertyId, dataObservation.id);
      updateDataObservations(props.propertyId);
      
    }
  }, [saveSuccess, saveLocation, dataTransfer, props.propertyId, cancelSave, dataObservation, cancelSaveArea])

  const onSaved = (savedObservation) => {
    updateDataObservations(props.propertyId);
    props.updatePropertyDetail(props.propertyId);
  }

  const handleRemoveObservation = (object, e) => {
    props.handleSetDeletedObservations(object.id);
  }
  
  

  const handleEditObservation = (object, e) => {
    let LatLng = e.target.getLatLng();
    object.lat = LatLng.lat;
    object.lng = LatLng.lng;
    props.handleSetUpdatedObservations(object, LatLng);
    setDataObservation(object);
  }
  
  const handleShowObservations = (data) => {
    var html = [];
    if(data.length > 0){
      _.forEach(data, function(observation){
        if (!observation.lat || !observation.lng) return;
        html.push(
          <Marker
            key={observation.id}
            position={[observation.lat, observation.lng]}
            icon={IconObservation()}
            onClick={handleClickObservation.bind(this, observation)}
            onDragEnd={handleEditObservation.bind(this, observation)}
            onRemove={handleRemoveObservation.bind(this, observation)}
            ref={el => (objectRef.current[observation.id] = el)}
          />
        );
      });
    }
    return html;
  }

  const handleClickObservation = (object, e) => {
    //Not trigger anything if on deleted state
    if(!props.controlDraw.current.leafletElement._toolbars.edit._modes.remove || !props.controlDraw.current.leafletElement._toolbars.edit._modes.remove.handler._enabled){
      const modalData = {
        object,
        type: 'observation'
      }
      dispatch(openModal(modalData));
    }
  }

  const editLocation = () => {
    const data = {
      objectRef,
      dataId: modalData.object.id,
      type: 'observation'
    }
    dispatch(show(data));
    setDataObservation(modalData.object);
    objectRef.current[modalData.object.id].leafletElement.editing.enable();
  }

  return (
    <>
      {handleShowObservations(observations)}
      <ObservationModal
        propertyId={props.propertyId}
        primaryObjects={primaryObjects}
        onSaved={onSaved}
        editLocation={editLocation}
        updatePropertyDetail = {props.updatePropertyDetail}
      />
    </>
  );
}

export default Observation;
